export default [
  // 模式设置-编辑
  {
    path: '/myCar-modeSetting-index',
    component: () => import('@/views/myCar/modeSetting/Index.vue'),
    name: 'myCar-modeSetting-index',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // 模式设置-登录
  {
    path: '/myCar-modeSetting-login',
    component: () => import('@/views/myCar/modeSetting/Login.vue'),
    name: 'myCar-modeSetting-login',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // ota
  {
    path: '/myCar-ota-upgrade',
    component: () => import('@/views/myCar/ota/Upgrade.vue'),
    name: 'myCar-ota-upgrade',
    meta: {
      appName: 'OTAUpgrade',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },

  // 轨迹
  {
    path: '/myCar-trajectory-introduction',
    component: () => import('@/views/myCar/trajectory/Introduction.vue'),
    name: 'myCar-trajectory-introduction',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 微信消息提醒
  {
    path: '/myCar-weixinRemind',
    component: () => import('@/views/myCar/weixinRemind/Index.vue'),
    name: 'myCar-weixinRemind',
    meta: {
      auth: 0,
      title: '车辆提醒推送设置',
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },

  // 里程异常
  {
    path: '/myCar-abnormalMileage',
    component: () => import('@/views/myCar/abnormalMileage/Index.vue'),
    name: 'myCar-abnormalMileage',
    meta: {
      auth: 0,
      title: '里程异常查询',
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // 里程异常-查询结果
  {
    path: '/myCar-abnormalMileage-result-:vin',
    component: () => import('@/views/myCar/abnormalMileage/Result.vue'),
    name: 'myCar-abnormalMileage-result',
    meta: {
      auth: 0,
      title: '查询结果',
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
];
